import { gql } from "@apollo/client"

export const GET_SHARED_PLAN_TERMINALS_BY_ID = gql`
  query getSharedPlanTerminalData($apiPlanId: Int!) {
    sharedPlan(apiPlanId: $apiPlanId) {
      id
      start
      end
      sharedInstances {
        id
        name
        apiPlanId
        organization {
          id
          name
        }
        totalDataUsage
        volumeTotalAggregated
        volumeTopupAggregated
        terminal {
          id
          name
          active
          terminal {
            id
            modemSn
            warrantyEndDate
            serialNumber
            superAdminPassword
            imageUrl
            groups {
              id
              name
            }
          }
        }
      }
    }
  }
`
